export const LEAD_STATUSES = [
  { v: "new", l: "New", cls: "bg-[hsl(330_85%_93%)] text-[hsl(330_70%_38%)]" },
  { v: "walkthrough_booked", l: "Walk-through booked", cls: "bg-[hsl(175_45%_88%)] text-[hsl(175_70%_24%)]" },
  { v: "quoted", l: "Quoted", cls: "bg-[hsl(40_80%_88%)] text-[hsl(30_60%_30%)]" },
  { v: "won", l: "Won", cls: "bg-[hsl(120_30%_85%)] text-[hsl(140_40%_25%)]" },
  { v: "lost", l: "Lost", cls: "bg-muted text-muted-foreground" },
];

export const LEAD_SOURCES = ["Google", "Facebook", "Instagram", "Referral", "Website", "Flyer", "Word of mouth"];

export const statusMeta = (v) => LEAD_STATUSES.find((s) => s.v === v) || LEAD_STATUSES[0];
